import img01 from "../assets/images/OLYMPO29/ESTANDAR/salon-pasajeros---acabado-techo.jpg"
import img02 from "../assets/images/OLYMPO29/ESTANDAR/salon-pasajeros---acabado-lateral.jpg"
// import img02 from "../assets/images/olympo36/img02.jpg"
// import img03 from "../assets/images/olympo36/img03.jpg"
// import img04 from "../assets/images/olympo36/img04.jpg"
import img04 from "../assets/images/OLYMPO29/ESTANDAR/salon-pasajeros---iluminacion.jpg"
// import img05 from "../assets/images/olympo36/img05.jpg"
// import img06 from "../assets/images/olympo36/img06.jpg"
import img06 from "../assets/images/OLYMPO29/ESTANDAR/cabina-conductor---cupula.jpg"
// import img08 from "../assets/images/olympo36/img08.jpg"
import img08 from "../assets/images/OLYMPO29/ESTANDAR/cabina-conductor---tablero-de-control.jpg"
// import img09 from "../assets/images/olympo36/img09.jpg"
import img09 from "../assets/images/OLYMPO29/ESTANDAR/cabina-conductor---grada-de-ingreso.jpg"
// import img10 from "../assets/images/olympo36/img10.jpg"
import img10 from "../assets/images/OLYMPO29/ESTANDAR/exterior-1.jpg"
// import img11 from "../assets/images/olympo36/img11.jpg"
import img11 from "../assets/images/OLYMPO29/ESTANDAR/exterior-2.jpg"
// import img13 from "../assets/images/olympo36/img13.jpg"
import img13 from "../assets/images/OLYMPO29/OPCIONALES/calefaccion.jpg"
// import img14 from "../assets/images/olympo36/img14.jpg"
// import img15 from "../assets/images/olympo36/img15.jpg"
import img15 from "../assets/images/OLYMPO29/OPCIONALES/aire-acondicionado.jpg"
// import img17 from "../assets/images/olympo36/img17.jpg"
// import img18 from "../assets/images/olympo36/img18.jpg"
import img18 from "../assets/images/OLYMPO29/ESTANDAR/conduccion---accionamiento-de-puerta-de-servicio.jpg"
import img19 from "../assets/images/OLYMPO29/ESTANDAR/conduccion---panel-de-control.jpg"
import img20 from "../assets/images/OLYMPO29/ESTANDAR/exterior-3.jpg"
import img21 from "../assets/images/OLYMPO29/ESTANDAR/Olympo-29.jpg"
export const OlympoBlock1 = [
  {
    title: `ACABADO TECHO`,
    text: `Impermeable, de fácil limpieza, antinflamable y aislante térmico.<li></li> Decorado con PVC DECORATIVO.`,
    img: img01,
  },
  {
    title: `ACABADO LATERALES`,
    text: `Impermeable, de fácil limpieza, antinflamable y aislante térmico.<li></li> Perfilado de marcos de ventanas con PVC DECORATIVO de brillo natural.`,
    img: img02,
  },
  // IMG FALTA
  // {
  //   title: `ACABADO DE PISO`,
  //   text: `El piso es cubierto en PVC FLEXIBLE DE ALTO TRÁNSITO de alta resistencia al desgaste. Opciones de colores para el decorado del piso. Es antinflamable y retardante.`,
  //   img: img03,
  // },
  {
    title: `ILUMINACIÓN`,
    text: ` Iluminación con tecnología LED en ambos lados del salón.`,
    img: img04,
  },
  // {
  //   title: `PAQUETERAS`,
  //   text: ` LIGERAS y elaboradas en poliuretano rigido de alta densidad. Fijadas en el techo estratégicamente para EVITAR VIBRACIONES. Luces de lectura individuales con iluminación independiente. `,
  //   img: img05,
  //   textAlt: `*alternativa personalizable`,
  // },
]
export const OlympoBlock2 = [
  {
    title: `TABLERO DE CONTROL`,
    text: `<li>Diseño AERODINÁMICO elaborado en fibra de vidrio con colores elegantes. </li>
    <li>Su diseño FACILITA LA OPERACIÓN del bus.</li>`,
    img: img08,
  },
  {
    title: `GRADA DE INGRESO`,
    text: ` <li>Fabricado en fibra de vidrio reforzada con estructura metálica.</li>`,
    img: img09,
  },
  {
    title: `CÚPULA`,
    text: `<li>Elaborado en fibra de vidrio con lineas estilizadas decorativas y definición de contornos para la colocación de accesorios de cabina.</li>`,
    img: img06,
  },

]
export const OlympoBlock3 = [
  {
    title: `ISO FRONTAL`,
    text: `  <li>AERODINÁMICO Y ELEGANTE</li>`,
    img: img10,
  },
  {
    title: `ISO POSTERIOR`,
    text: ` <li>ELEGANTE</li>`,
    img: img11,
  },
  {
    title: "FRONTAL",
    text: "<li>Mascara, Parachoque y Trampilla.</li>",
    img: img20,
  },
]
export const OlympoBlock4 = [
  {
    title: `AIRE ACONDICIONADO`,
    text: `<li>Purifica y climatiza el aire del salón de pasajeros, garantizando comodidad y bienestar a los pasajeros.</li>`,
    
    img: img15,
  },
  {
    title: `CALEFACCIÓN`,
    text: `<li>En base a paneles de serpentín.</li>`,
    img: img13,
    // textAlt: `*alternativa personalizable`,
  },
  // {
  //   title: `ASIENTOS`,
  //   text: [
  //     {
  //       titulo: "Asiento SOFT",
  //       text: `Diseño ergonómico, suavidad en la reclinación y variedad de materiales y colores.
  //     Inyectados en poliuretano flexible con densidad de acuerdo al tipo de servicio. Precisión en el armado para evitar vibraciones y uso de componentes de amortiguación.`,
  //     }
  //   ],
  //   textAlt: `*alternativa personalizable`,
  //   img: img14,
  // },
  
]
export const OlympoBlock5 = [
  {
    title: "ACCIONAMIENTO PUERTA SERVICIO",
    text:
    "<li>El accionamiento de la puerta se realiza con la instalación de una comprensora eléctrica que deposita aire comprimido en un tanque especial.</li>",
    img: img18,
  },
  {
    title: "PANEL DE CONTROL",
    text: "<li>Espacioso</li>",
    img: img19,
  },
]
export const OlympoBlock6 = [
  {
    title: "Lorem ipsum dolor",
    text:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem aliquam est dolor numquam, ab voluptates.",
    img: img19,
  },

  {
    title: "Lorem ipsum dolor",
    text:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem aliquam est dolor numquam, ab voluptates.",
    img: img21,
  },
]
